import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Shopkeepers from './pages/Shopkeepers';
import Staff from './pages/Staff';
import Payments from './pages/Payments';
import Complaints from './pages/Complaints';
import Attendance from './pages/Attendance';
import Settings from './pages/Settings';
import Vehicles from './pages/Vehicles';
import NocRequests from './pages/NocRequests';
import Layout from './components/Layout';
// Super Admin Pages
import SuperAdminDashboard from './pages/superadmin/SuperAdminDashboard';
import Tenants from './pages/superadmin/Tenants';
import Notifications from './pages/Notifications';
import NotificationHistory from './pages/NotificationHistory';
import './App.css';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            {/* Admin Routes */}
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="shopkeepers" element={<Shopkeepers />} />
            <Route path="staff" element={<Staff />} />
            <Route path="payments" element={<Payments />} />
            <Route path="complaints" element={<Complaints />} />
            <Route path="attendance" element={<Attendance />} />
            <Route path="vehicles" element={<Vehicles />} />
            <Route path="noc-requests" element={<NocRequests />} />
            <Route path="settings" element={<Settings />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="notifications/history" element={<NotificationHistory />} />
            {/* Super Admin Routes */}
            <Route path="super-admin/dashboard" element={<SuperAdminDashboard />} />
            <Route path="super-admin/tenants" element={<Tenants />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;

